module.exports = __webpack_public_path__ + "static/img/图层 52.4133a3fd.png";